import React from "react";
import type { ILoadingComponentProps } from "./_models";
import LoadingItem from "./LoadingItem";

export const LoadingContext = React.createContext({
  loading: false,
  showLoading: () => {},
  hideLoading: () => {},
});

export const useLoading = () => React.useContext(LoadingContext);

const LoadingComponent = (props: ILoadingComponentProps) => {
  const [loading, setLoading] = React.useState(false);
  const value = React.useMemo(
    () => ({
      loading: loading,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
    }),
    [loading],
  );

  return (
    <LoadingContext.Provider value={value}>
      {props.children}
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div className="flex h-[200px] w-[200px] items-center justify-center rounded-[15px] bg-white shadow">
            <svg
              id="L9"
              x="0px"
              y="0px"
              viewBox="0 0 100 100"
              enableBackground="new 0 0 0 0"
              xmlSpace="preserve"
              aria-labelledby="loadingTitle"
            >
              <title id="loadingTitle">Loading animation</title>
              <path
                fill="#8095FF"
                d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
              >
                <animateTransform
                  attributeName="transform"
                  attributeType="XML"
                  type="rotate"
                  dur="1s"
                  from="0 50 50"
                  to="360 50 50"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

LoadingComponent.LoadingItem = LoadingItem;
export default LoadingComponent;
